RivalIQ.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.Users = Backbone.Collection.extend({
        model: RivalIQ.models.User,
        url: function () {
            const me = this;
            return `/api/account/${me.account_id}/users`;
        },

        comparator: function (a, b) {
            const aName = a.get('last_name');
            const bName = b.get('last_name');

            if (!aName) {
                return -1;
            }

            if (!bName) {
                return 1;
            }

            return aName.localeCompare(bName);
        },

        parse: function (attrs) {
            return attrs.users;
        }
    });
});
